export default __webpack_public_path__ + "static/media/Volume.0fd6b5bd.svg";